import React, { useEffect, useState } from "react";
import { api } from "@/lib/config";
import { Plus, Edit2, Trash2, X, Save } from "lucide-react";

const EMPTY = { title: "", description: "", file_url: "", category: "Ressource", order: 0 };

export default function AdminResources() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY);

  const load = () => api.get("/resources").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const onSave = async () => {
    if (editing === "new") await api.post("/admin/resources", form);
    else await api.put(`/admin/resources/${editing}`, form);
    setEditing(null); load();
  };

  const onDelete = async (id) => {
    if (!window.confirm("Supprimer cette ressource ?")) return;
    await api.delete(`/admin/resources/${id}`); load();
  };

  return (
    <div>
      <div className="flex items-end justify-between">
        <div>
          <p className="section-num">Ressources</p>
          <h1 className="display text-4xl mt-3">Ressources téléchargeables</h1>
        </div>
        <button onClick={() => { setEditing("new"); setForm(EMPTY); }} className="btn-pill btn-primary" data-testid="admin-new-resource">
          <Plus size={16}/> Nouvelle ressource
        </button>
      </div>

      <div className="mt-12 bg-paper border border-ink/10">
        {items.length === 0 && <p className="p-8 text-ink/60">Aucune ressource.</p>}
        {items.map(r => (
          <div key={r.id} className="flex items-center justify-between p-5 border-b border-ink/10 last:border-b-0" data-testid={`admin-resource-${r.id}`}>
            <div className="flex-1 min-w-0">
              <p className="display text-lg truncate">{r.title}</p>
              <p className="text-sm text-ink/60 truncate">{r.category} · {r.description}</p>
            </div>
            <div className="flex gap-2 ml-4">
              <button onClick={() => { setEditing(r.id); setForm({ title: r.title, description: r.description, file_url: r.file_url, category: r.category, order: r.order }); }} className="p-2 hover:bg-ink/5"><Edit2 size={16}/></button>
              <button onClick={() => onDelete(r.id)} className="p-2 hover:bg-paper-2 text-accent-pink"><Trash2 size={16}/></button>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-6" onClick={() => setEditing(null)}>
          <div className="bg-paper max-w-2xl w-full" onClick={(e) => e.stopPropagation()}>
            <div className="p-8 border-b border-ink/10 flex items-center justify-between">
              <h2 className="display text-2xl">{editing === "new" ? "Nouvelle ressource" : "Modifier"}</h2>
              <button onClick={() => setEditing(null)}><X size={22}/></button>
            </div>
            <div className="p-8 space-y-5">
              <div><label className="text-xs uppercase tracking-wider text-ink/60">Titre</label><input className="field" value={form.title} onChange={e => setForm(f => ({ ...f, title: e.target.value }))}/></div>
              <div><label className="text-xs uppercase tracking-wider text-ink/60">Description</label><textarea className="field" rows={3} value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))}/></div>
              <div><label className="text-xs uppercase tracking-wider text-ink/60">URL du fichier</label><input className="field" value={form.file_url} onChange={e => setForm(f => ({ ...f, file_url: e.target.value }))}/></div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div><label className="text-xs uppercase tracking-wider text-ink/60">Catégorie</label><input className="field" value={form.category} onChange={e => setForm(f => ({ ...f, category: e.target.value }))}/></div>
                <div><label className="text-xs uppercase tracking-wider text-ink/60">Ordre</label><input type="number" className="field" value={form.order} onChange={e => setForm(f => ({ ...f, order: parseInt(e.target.value) || 0 }))}/></div>
              </div>
              <div className="flex gap-3 pt-4">
                <button onClick={onSave} className="btn-pill btn-primary" data-testid="admin-save-resource"><Save size={16}/> Enregistrer</button>
                <button onClick={() => setEditing(null)} className="btn-pill btn-ghost">Annuler</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
